const projectDatasetsSplitView = {
  archivedHint:
    "This project is archived and read-only. Restore it in Settings -> Project Controls first.",
  empty: "No datasets in this project yet.",
  selectAll: "Select all · {{count}} datasets",
  downloading: "Downloading…",
  downloadSelected: "Download ({{count}})",
  requestAccessOne: "Request access (1)",
  requestAccessNote:
    "Access is requested one dataset at a time — select a single dataset, or use Request access in its detail view.",
  rowCount: "{{value}} rows",
  hiddenFromNonAdminsTitle: "Hidden from non-admin users",
  expired: "Expired",
  noAccess: "No access",
  detailEmpty: "Select a dataset to see its columns and summary statistics.",
  downloadWorkbook: "Download workbook",
  downloadAsCsv: "Download as CSV",
  downloadCsvHint: "Flattened first sheet, supports selecting a column subset",
  requestAccess: "Request access",
  projectArchived: "Project archived",
  visibility: {
    hidden: "Hidden from non-admins",
    visible: "Visible to project",
  },
  uploadedBy: "Dataset uploaded by {{uploader}} on {{date}}",
  uploadedBySomeone: "someone",
  downloadFailed: "Download failed",
  expiryEditable: {
    set: "Expires {{date}}",
    none: "No expiry set",
    edit: "Edit",
  },
};

export default projectDatasetsSplitView;
